/**
 * Note class.
 */
export default class Note {
    /**
     * @param {String} objectId - Object id
     * @param {String} content - content
     * @constructor
     */
    constructor(objectId, content) {
        this.object_id = objectId;
        this.content = content;
    }
}



// WEBPACK FOOTER //
// ./app/services/api/notes/note.class.js